export type MADSeriesTypesEnum = MADSummarySeriesTypesEnum | MADSentimentSeriesTypesEnum | MADSocialSeriesTypesEnum;

export enum MADSummarySeriesTypesEnum {
    totalVolumeCard,
    totalVolumeCardPreviousPeriod,
    totalImpressionCard,
    totalImpressionCardPreviousPeriod,
    totalAVECard,
    totalAVECardPreviousPeriod,
    summaryTrend,
    positive,
    positivePreviousPeriod,
    neutral,
    neutralPreviousPeriod,
    negative,
    negativePreviousPeriod,
    averageDomainAuthority,
    averageDomainAuthorityPreviousPeriod,
    map,
    mediaTypeBreakdown,
    topOutlets,
    topAuthors,
    topMentions
};

export enum MADSummaryChartTypesEnum {
    summaryTrend,
    mediaTypeBreakdown,
    map,
    topAuthors,
    topOutlets,
    topMentions
};

export enum MADSentimentSeriesTypesEnum {
    trend,
    positive,
    positivePreviousPeriod,
    neutral,
    neutralPreviousPeriod,
    negative,
    negativePreviousPeriod,
    sentimentByMediaType,
    positiveMap,
    negativeMap,
    topMentions,
    topMentionsSummary,
    positiveTopTerms,
    negativeTopTerms,
    positiveWordCloud,
    negativeWordCloud,
    positiveAuthors,
    negativeAuthors,
    positiveOutlets,
    negativeOutlets
};

export enum MADSocialSeriesTypesEnum {
    totalVolumeCard,
    totalVolumeCardPreviousPeriod,
    totalImpressionCard,
    totalImpressionCardPreviousPeriod,
    totalEngagementCard,
    totalEngagementCardPreviousPeriod,

    summaryTrend,
    summaryTotalVolumeCard,
    summaryTotalVolumeCardPreviousPeriod,
    summaryTotalImpressionCard,
    summaryTotalImpressionCardPreviousPeriod,
    summaryTotalEngagementCard,
    summaryTotalEngagementCardPreviousPeriod,

    totalVolumePie,
    totalVolumePiePreviousPeriod,
    totalImpressionPie,
    totalImpressionPiePreviousPeriod,
    totalEngagementPie,
    totalEngagementPiePreviousPeriod,

    sentimentTrend,
    topTerms,
    topPosts
};
